import { Button } from "@/components/ui/button";
import { Navbar } from "@/components/Navbar";
import { Benefits } from "@/components/Benefits";
import { HowItWorks } from "@/components/HowItWorks";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-primary mb-6">
              Hire Elite Software Engineers
              <span className="block text-secondary">Within 48 Hours</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Access a network of pre-vetted senior developers ready to join your
              team and make an immediate impact.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg" 
                className="bg-primary hover:bg-primary/90"
                onClick={() => navigate('/auth', { state: { preselectedType: 'company' } })}
              >
                Hire Developers
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                onClick={() => navigate('/auth', { state: { preselectedType: 'developer' } })}
              >
                Join Our Talent Pool
              </Button>
            </div>
          </div>
          
          <div className="mt-16 flex justify-center">
            <img
              src="/assets/photo-1522071820081-009f0129c71c.jpg"
              alt="Team of developers collaborating in a modern office"
              className="rounded-lg shadow-xl max-w-full h-auto"
            />
          </div>
        </div>
      </section>

      <Benefits />
      <HowItWorks />

      {/* CTA Section */}
      <section className="py-20 bg-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Ready to Build Your Dream Team?
          </h2>
          <p className="text-lg mb-8 opacity-90 max-w-2xl mx-auto">
            Get started today and connect with top-tier developers who can take
            your projects to the next level.
          </p>
          <Button
            size="lg"
            className="bg-white text-primary hover:bg-gray-100"
            onClick={() => navigate('/auth', { state: { preselectedType: 'company' } })}
          >
            Start Hiring Now
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Index;